import Playlist from '../../models/Playlist'
import { loadPlanEntriesSuccess } from '../../redux/actions/planEntries'

const NUM_PLAYLISTS_PER_FETCH = 5

export const CLEAR_PLAYLIST_ENTRIES = 'CLEAR_PLAYLIST_ENTRIES'
export const START_FETCH_PLAYLISTS = 'START_FETCH_PLAYLISTS'
export const FETCH_PLAYLISTS_SUCCESS = 'FETCH_PLAYLISTS_SUCCESS'
export const FETCH_PLAYLISTS_ERROR = 'FETCH_PLAYLISTS_ERROR'
export const SET_PLAYLIST_ORDER = 'SET_PLAYLIST_ORDER'
export const START_CREATE_NEW_PLAYLIST = 'START_CREATE_NEW_PLAYLIST'
export const FINISH_CREATE_NEW_PLAYLIST = 'FINISH_CREATE_NEW_PLAYLIST'
export const SET_DISPLAYED_PLAYLIST = 'SET_DISPLAYED_PLAYLIST'
export const START_FETCH_PLAYLIST_ENTRIES = 'START_FETCH_PLAYLIST_ENTRIES'
export const FETCH_PLAYLIST_ENTRIES_SUCCESS = 'FETCH_PLAYLIST_ENTRIES_SUCCESS'
export const SET_DISPLAYED_PLAYLIST_ENTRIES_ORDER =
  'SET_DISPLAYED_PLAYLIST_ENTRIES_ORDER'
export const PLAYLIST_FEATURED = 'PLAYLIST_FEATURED'
export const PLAYLIST_UNFEATURED = 'PLAYLIST_UNFEATURED'
export const PLAYLIST_UPDATED = 'PLAYLIST_UPDATED'
export const PLAYLIST_DELETED = 'PLAYLIST_DELETED'
export const REORDER_USER_PLAYLISTS = 'REORDER_USER_PLAYLISTS'

export function startCreateNewPlaylist () {
  return {
    type: START_CREATE_NEW_PLAYLIST
  }
}

export function finishCreateNewPlaylist (playlist, firstPlanEntryId) {
  return {
    type: FINISH_CREATE_NEW_PLAYLIST,
    playlist,
    firstPlanEntryId
  }
}

export function setDisplayedPlaylist (playlist) {
  return {
    type: SET_DISPLAYED_PLAYLIST,
    playlist
  }
}

export function setDisplayedPlaylistEntriesOrder (orderObj) {
  return {
    type: SET_DISPLAYED_PLAYLIST_ENTRIES_ORDER,
    orderObj
  }
}

export function createNewPlaylist (
  playlistTitle,
  firstPlanEntryId,
  callback = () => {}
) {
  return dispatch => {
    dispatch(startCreateNewPlaylist())
    Playlist.createNew(playlistTitle, firstPlanEntryId).then(res => {
      dispatch(finishCreateNewPlaylist(res.data, firstPlanEntryId))
      callback(res.data)
    })
  }
}

export function setOrder (order) {
  return {
    type: SET_PLAYLIST_ORDER,
    order
  }
}

export function startFetchPlaylists (reloadAll) {
  return {
    type: START_FETCH_PLAYLISTS,
    reloadAll
  }
}

export function fetchPlaylistsSuccess (playlists, total, reloadAll) {
  return {
    type: FETCH_PLAYLISTS_SUCCESS,
    playlists,
    total,
    reloadAll
  }
}

export function fetchPlaylistsError (error) {
  return {
    type: FETCH_PLAYLISTS_ERROR,
    error
  }
}

export function clearPlaylistEntries () {
  return {
    type: CLEAR_PLAYLIST_ENTRIES
  }
}

export function startFetchPlaylistEntries () {
  return {
    type: START_FETCH_PLAYLIST_ENTRIES
  }
}

export function fetchPlaylistEntriesSuccess () {
  return {
    type: FETCH_PLAYLIST_ENTRIES_SUCCESS
  }
}

export function playlistFeatured (uuid) {
  return {
    type: PLAYLIST_FEATURED,
    uuid
  }
}

export function playlistUnfeatured (uuid) {
  return {
    type: PLAYLIST_UNFEATURED,
    uuid
  }
}

export function playlistUpdated (uuid, params) {
  return {
    type: PLAYLIST_UPDATED,
    uuid,
    params
  }
}

export function playlistDeleted (uuid) {
  return {
    type: PLAYLIST_DELETED,
    uuid
  }
}

export function reorderUserPlaylists (order) {
  return {
    type: REORDER_USER_PLAYLISTS,
    order
  }
}

export function fetchPlaylists (reloadAll, callback = () => {}) {
  return (dispatch, getState) => {
    dispatch(startFetchPlaylists(reloadAll))
    const state = getState()
    const page = state.ui.playlists.page
    Playlist.findAll({
      order: state.ui.playlists.order,
      per_page: NUM_PLAYLISTS_PER_FETCH,
      page
    })
      .then(res => {
        dispatch(fetchPlaylistsSuccess(res.data, res.headers.total, reloadAll))
        callback()
      })
      .catch(e => {
        dispatch(fetchPlaylistsError(e))
      })
  }
}

export function fetchPlaylistEntries (playlist) {
  return (dispatch, getState) => {
    const state = getState()

    const page = state.ui.playlists.playlistEntriesPage

    dispatch(startFetchPlaylistEntries())

    let entryParams = {
      per_page: 20,
      page,
      ...state.ui.playlists.entriesOrder
    }

    playlist.fetchPlanEntries(entryParams).then(response => {
      dispatch(fetchPlaylistEntriesSuccess())
      dispatch(loadPlanEntriesSuccess(response.data, response.headers.total))
    })
  }
}

export function featurePlaylist (playlist) {
  return dispatch => {
    return new Promise(resolve => {
      playlist.feature().then(() => {
        dispatch(playlistFeatured(playlist.uuid))
        resolve()
      })
    })
  }
}

export function unfeaturePlaylist (playlist) {
  return dispatch => {
    return new Promise(resolve => {
      playlist.unfeature().then(() => {
        dispatch(playlistUnfeatured(playlist.uuid))
        resolve()
      })
    })
  }
}

export function updatePlaylist (playlist, params, callback) {
  return dispatch => {
    playlist.updateBackend(params).then(res => {
      dispatch(playlistUpdated(playlist.uuid, res.data))
      if (callback) callback()
    })
  }
}
